const CC_CONTAINER_TYPES = {
	ApiInterface: Symbol.for('ApiInterface'),
	CcServiceInterface: Symbol.for('CcServiceInterface'),
	CcApplicationInterface: Symbol.for('CcApplicationInterface')
};

export { CC_CONTAINER_TYPES };
